module.exports = __webpack_public_path__ + "img/warning-yellow.9e5dd0de.png";